export const open_replace_dialog = () => ({
    type: 'REPLACE_DIALOG__OPEN',
});
export const close_replace_dialog = () => ({
    type: 'REPLACE_DIALOG__CLOSE',
});
export const replace_device = (broken_device_id, replacement_device_id) => async (dispatch, getState, { api }) => {
    dispatch({
        type: 'REPLACE_DEVICE__REQUEST',
        broken_device_id,
        replacement_device_id,
    });
    try {
        await api.replace_device(broken_device_id, replacement_device_id);
        dispatch({
            type: 'REPLACE_DEVICE__OK',
            broken_device_id,
            replacement_device_id,
        });
    }
    catch (error) {
        dispatch({
            type: 'REPLACE_DEVICE__FAIL',
            broken_device_id,
            replacement_device_id,
            error: error?.json?.error_ui ??
                error?.json?.error ??
                'Не удалось отправить запрос',
        });
    }
};
